import { Modal, ModalOverlay, ModalContent } from "@chakra-ui/react";
import { ReactNode } from "react";

const ConfirmPopupLayout = ({
  isOpen,
  onClose,
  children,
}: {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
    >
      <ModalOverlay bg={"transparent"} />
      <ModalContent
        bg={"--20"}
        borderRadius="6px"
        border={"1px solid #3E4042"}
        width="350px"
        boxShadow="lg"
        h="max-content"
        onClick={(e) => e.stopPropagation()} // Trash popup이 꺼지지 않도록 설정
      >
        {children}
      </ModalContent>
    </Modal>
  );
};

export default ConfirmPopupLayout;
